import styled, { StyledProps } from 'styled-components/macro';

export type ToastStylesProps = StyledProps<{
  error: boolean
}>;

export const Container = styled.div<ToastStylesProps>`
  position: fixed;
  width: 350px;
  min-height: 72px;
  top: 20px;
  right: 20px;
  background-color: #fff;
  box-shadow: 0px 8px 10px rgba(129, 129, 129, 0.1), 0px 3px 14px rgba(129, 129, 129, 0.08), 0px 5px 5px rgba(129, 129, 129, 0.16);
  border-radius: 3px;
  overflow: hidden;
  padding: 13px 23px;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 8px;
    background-color: ${props => props.error ? '#CF4845' : '#2E8540'};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconStatus = styled.div`
  width: 18px;
  margin-right: 8px;
  margin-top: -3px;
`;

export const Title = styled.div<ToastStylesProps>`
  font-weight: bold;
  font-size: 14px;
  color: ${props => props.error ? '#CF4845' : '#2E8540'};
`;

export const IconClose = styled.div`
  width: 12px;
  cursor: pointer;
`;

export const Content = styled.div`
  font-size: 14px;
  color: #1B1B1B;
  margin-top: 8px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
